define("shared/components/shared-carousel/carousel-inner", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/template-only",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="carousel-inner eCP--slide u--m__b__0" role="listbox" ...attributes>
    {{#if (has-block)}}
      {{#each @carouselMediaItems as |media idx|}}
        <div class="item cCP--slide__item {{if (is-equal idx @index) "active"}}" role="option">
          {{yield (hash media=media)}}
        </div>
      {{/each}}
    {{else}}
      {{#each @carouselMediaItems as |media idx|}}
        <div class="item {{if (is-equal idx @index) "active"}}" role="listbox">
          {{#if (is-equal media.type "video")}}
            <video class=" video-js vjs-default-skin" alt={{media.caption}} controls preload="auto" width="640" height="640"
              data-setup="{'controls': true, 'autoplay': true, 'preload': 'auto', 'loop': 'true'}">
              <source src={{media.standardResVideoUrl}} type="video/mp4">
            </video>
          {{else}}
            <img src={{media.standardResUrl}} alt={{media.caption}} class="o--media" role="option">
          {{/if}}
        </div>
      {{/each}}
    {{/if}}
  </div>
  */
  {
    "id": "vl5it2ep",
    "block": "[[[11,0],[24,0,\"carousel-inner eCP--slide u--m__b__0\"],[24,\"role\",\"listbox\"],[17,1],[12],[1,\"\\n\"],[41,[48,[30,8]],[[[42,[28,[37,3],[[28,[37,3],[[30,2]],null]],null],null,[[[1,\"      \"],[10,0],[15,0,[29,[\"item cCP--slide__item \",[52,[28,[37,4],[[30,4],[30,5]],null],\"active\"]]]],[14,\"role\",\"option\"],[12],[1,\"\\n        \"],[18,8,[[28,[37,6],null,[[\"media\"],[[30,3]]]]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[3,4]],null]],[]],[[[42,[28,[37,3],[[28,[37,3],[[30,2]],null]],null],null,[[[1,\"      \"],[10,0],[15,0,[29,[\"item \",[52,[28,[37,4],[[30,7],[30,5]],null],\"active\"]]]],[14,\"role\",\"listbox\"],[12],[1,\"\\n\"],[41,[28,[37,4],[[30,6,[\"type\"]],\"video\"],null],[[[1,\"          \"],[10,\"video\"],[14,0,\" video-js vjs-default-skin\"],[15,\"alt\",[30,6,[\"caption\"]]],[14,\"controls\",\"\"],[14,\"preload\",\"auto\"],[14,\"width\",\"640\"],[14,\"height\",\"640\"],[14,\"data-setup\",\"{'controls': true, 'autoplay': true, 'preload': 'auto', 'loop': 'true'}\"],[12],[1,\"\\n            \"],[10,\"source\"],[15,\"src\",[30,6,[\"standardResVideoUrl\"]]],[14,4,\"video/mp4\"],[12],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],[[[1,\"          \"],[10,\"img\"],[15,\"src\",[30,6,[\"standardResUrl\"]]],[15,\"alt\",[30,6,[\"caption\"]]],[14,0,\"o--media\"],[14,\"role\",\"option\"],[12],[13],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n\"]],[6,7]],null]],[]]],[13]],[\"&attrs\",\"@carouselMediaItems\",\"media\",\"idx\",\"@index\",\"media\",\"idx\",\"&default\"],false,[\"if\",\"has-block\",\"each\",\"-track-array\",\"is-equal\",\"yield\",\"hash\"]]",
    "moduleName": "shared/components/shared-carousel/carousel-inner.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});